import { Pipe, PipeTransform } from '@angular/core';
import { format, isValidNumber, parse, ParsedNumber } from 'libphonenumber-js';

@Pipe({
    name: 'phone',
    standalone: true
})
export class PhonePipe implements PipeTransform {
  transform(value: string, args?: string): any {
    if (!value) {
      return value;
    }

    if (value.charAt(0) !== '+') {
      value = '+' + value;
    }

    const phoneNumber: ParsedNumber = parse(value);

    return isValidNumber(phoneNumber) ? format(phoneNumber, 'NATIONAL') : value;
  }
}
